import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

import { Box, Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckShortLogo from '../../global/components/helper-components/components/LaunchdeckShortLogo';


function OrgUpCtaModule({ userAccountProfile }) {

  const history = useHistory();
  const { email, firstName, lastName } = userAccountProfile || {};

  const handleClickSetupEnquiry = () => {
    const prepopName = (firstName && lastName) ? firstName + ' ' + lastName : firstName ? firstName : "";
    history.push('/signup', { prepopEmail: email, prepopName: prepopName.trim(), redirectBackRoute: "/profile" });
  }

  return (
    <Box w='100%'>
      <Box className="user-profile-section__first-label" letterSpacing='1px' fontSize='1.2em'> Organization Profile</Box>

      <Box
        border='1px solid' borderColor='gray.300' rounded='0.25em' p='0.25em' my='1em'
        bgGradient="linear(to-r, #FF2847, #29ABE2)"
      >

        <Flex
          w='100%'
          rounded='0.25em'
          color='brandDark.500'
          justify='space-between'
          align='flex-start'
          p='0.5em'
          border='1px solid'
          borderColor='brand.300'
          bg='white'
        >
          <Flex justify='flex-start' gap={4}>

            <Box px='0.5em'>
              <Flex pt='0.5em' align='flex-start' justify='space-between' w='100%'>
                <LaunchdeckShortLogo boxSize='1.5em' />
              </Flex>
              <Flex fontSize='0.875em' fontWeight='600' mt='0.5em' textAlign={['center', 'left']} align='center' gap={4}>Thinking about setting up your own Rooms to engage your own clients? </Flex>
              <Box fontSize='0.8em' color='gray.500' mt='0.25em' textAlign={['center', 'left']}>Create Rooms, engage, and obtain user analytics to know what your audience's true interests are </Box>

              <Box mt='2em' mb='0.5em'>
                <Flex justify={['center', 'flex-start']} w='100%' mt='1em'>
                  <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleClickSetupEnquiry()} label='Try it for free' />
                </Flex>
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  )
}


const mapStateToProps = (state) => ({
  userAccountProfile: state.userProfile.accountUserProfile
})

export default withRouter(connect(mapStateToProps, null)(OrgUpCtaModule))